import React, { ReactElement, useRef } from 'react';
import {
  animated, useChain, useSpring, useSpringRef,
} from 'react-spring';
import style from './style.module.scss';
import { Typography, TypographyVariants } from '../../ui/typography';

import { useIntersectionObserver } from '../../../utils/hooks/useIntersectionObserver';

export const ReadySection = (): ReactElement => {
  const sectionRef = useRef();
  const isVisible = useIntersectionObserver(sectionRef);
  const shadeSpringRef = useSpringRef();
  const sectionSpringRef = useSpringRef();
  const titleSpringRef = useSpringRef();

  const sectionStyle = useSpring({ opacity: isVisible ? 1 : 0, ref: sectionSpringRef });
  const titleStyle = useSpring({ scale: isVisible ? 0.5 : 1, y: isVisible ? -150 : 0, ref: titleSpringRef });

  useChain([shadeSpringRef, titleSpringRef, sectionSpringRef], [0, 0.5, 0.5]);

  return (
    <section className={style.section}>
      <div className={style.readySection}>
        <animated.h3 ref={sectionRef as any} style={titleStyle} className={style.readyTitle}>Готовы?</animated.h3>
      </div>
      <animated.div className={style.stepSection} style={sectionStyle}>
        <Typography variant={TypographyVariants.pLargeXL} component="h3">Сокращаем дистанцию</Typography>
        <Typography variant={TypographyVariants.h3} className={style.subtitle} component="span">3 простых шага до синхронизации</Typography>
      </animated.div>
    </section>
  );
};
